interface ShowPasswordButtonProps {
	setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
	showPassword: boolean;
}

export const ShowPasswordButton = ({
	setShowPassword,
	showPassword,
}: ShowPasswordButtonProps) => (
	<button
		aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
		className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
		data-testid="button_show_password"
		onClick={() => setShowPassword((prev) => !prev)}
		style={{
			position: "absolute",
			right: "8px",
			top: "50%",
			transform: "translateY(-50%)",
			background: "none",
			border: "none",
			cursor: "pointer",
			padding: 0,
			display: "flex",
			alignItems: "center",
		}}
		tabIndex={-1}
		type="button"
	>
		{showPassword ? (
			<span
				className="material-symbols-rounded"
				data-testid="span_button_icon_visibility_on"
				style={{ fontSize: "16px" }}
			>
				visibility
			</span>
		) : (
			<span
				className="material-symbols-rounded text-sm"
				data-testid="span_button_icon_visibility_off"
				style={{ fontSize: "16px" }}
			>
				visibility_off
			</span>
		)}
	</button>
);
